module.exports = __webpack_public_path__ + "img/icb-leo-Inte-e@2x.fd8a7da0.png";